export interface Estado {
  codigoIbge: number;
  codigoCep: number;
  sigla: string;
  nome: string;
}
